var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "chapter-admin" },
    [
      _vm.adminMenu
        ? _c("AdminMenu", {
            attrs: {
              items: _vm.adminMenu.items,
              badges: _vm.adminMenu.badges,
              orientation: ["top", "left"],
              "include-create-lesson-button":
                _vm.chapter.lessons_enabled && _vm.courseVersionName === ""
            },
            on: {
              "create-lesson": function($event) {
                _vm.isCreateLessonModalOpen = true
              }
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.shouldShowGoogleClassroomButton && _vm.isGoogleClassroomsReadyToRender
        ? _c("GoogleClassroomButton", {
            attrs: {
              "content-type": "chapter",
              "content-id": _vm.chapter.chapter_id,
              "content-title": _vm.chapter.name,
              "content-blurb": _vm.chapter.intro_blurb,
              "content-url": "" + _vm.baseUrl + _vm.chapter.quizzes[0].link
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.isCreateLessonModalOpen
        ? _c("CreateLessonModal", {
            attrs: { chapterSlug: _vm.chapter.slug },
            on: {
              close: function($event) {
                _vm.isCreateLessonModalOpen = false
              }
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }